import React from 'react';
import { FilterBar } from '../../filter/FilterBar';

export const TopBar = () => {
  return (<FilterBar />);
};
